import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

export const FormikFormErrorLogger = ({ onValidationErrors = () => {} }) => {
	const { isValid, isValidating, isSubmitting, errors } = useFormikContext();

	useEffect(() => {
		if (!isValid && !isValidating && isSubmitting) {
			console.error('FormikFormErrorLogger', errors);
			onValidationErrors(errors);
		}
	}, [isSubmitting, isValid, isValidating, errors, onValidationErrors]);

	return null;
};

FormikFormErrorLogger.propTypes = {
	onValidationErrors: PropTypes.func,
};
